var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade pe-0",
      attrs: {
        id: _vm.id,
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": _vm.ariaLabelledby,
        "aria-hidden": "true",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-dialog-slideout",
          attrs: { role: "document" },
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c(
                "button",
                {
                  staticClass: "btn-close ob1-link no-decoration",
                  attrs: {
                    type: "button",
                    "data-bs-dismiss": "modal",
                    "aria-label": "Fermer",
                  },
                  on: { click: _vm.clickHandler },
                },
                [
                  _c("span", {
                    staticClass: "icon icon-delete",
                    attrs: { "aria-hidden": "true" },
                  }),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [_vm._t("default")], 2),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c("div", { staticClass: "row mx-0" }, [
                _c("div", { staticClass: "col-12 px-0" }, [
                  _vm.withCloseButton
                    ? _c("button", {
                        directives: [
                          {
                            name: "msh-html",
                            rawName: "v-msh-html",
                            value: _vm.buttonLabel,
                            expression: "buttonLabel",
                          },
                        ],
                        staticClass: "btn btn-primary",
                        attrs: { type: "button", "data-bs-dismiss": "modal" },
                        on: { click: _vm.clickHandler },
                      })
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 px-0" },
                  [
                    _vm.deleteSelectionLabel
                      ? _c("lien", {
                          staticClass: "mt-1 noDefaultStyleButton",
                          attrs: {
                            "is-button": true,
                            label: _vm.deleteSelectionLabel,
                            disabled: _vm.numberOfSelectedFilters === 0,
                          },
                          on: { click: _vm.deleteSelectionClick },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }